import React from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types'
import Image from "../Image";

const JournalData = (props) => {
    const {description, image, title} = props;
  return (
    
      <div className="article-1 circular-std-book">
        <div className="article-1-img">
          <Image className="img-fluid center-block transition img-100" image={image} />
        </div>
        <div className="article-1-content">
          <span className="article-1-date gibson-normal">5 July 2017</span>
          <h3>
            {title}
          </h3>
          <p>
           {description}
          </p>
          <Link to="#" className="article-1-more">
            Read More
          </Link>
        </div>
      </div>
    
  );
};

JournalData.prototype = {
  description : PropTypes.string,
  image : PropTypes.string.isRequired,
  title : PropTypes.node
}

export default JournalData;
